/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_ImportInputs */

const en_notify_import = /** @type {(inputs: Notify_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import finished`)
};

const de_notify_import = /** @type {(inputs: Notify_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import fertig`)
};

/**
* | output |
* | --- |
* | "Import finished" |
*
* @param {Notify_ImportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_import = /** @type {((inputs?: Notify_ImportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_ImportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_import(inputs)
	return en_notify_import(inputs)
});